import {MinicartBody} from './partials/minicartBody'
import {MinicartFooter} from './partials/minicartFooter'
import {MinicartHeader} from './partials/minicartHeader'
import {MinicartProduct} from './partials/minicart-product'

export {MinicartHeader, MinicartBody, MinicartFooter, MinicartProduct}
